import { WidgetBase } from '../../models';
import { Helper } from '../../../common';

import { QualityBadActorsWidgetDefinition as definition } from './qualityBadActors.definition';
import { QualityWidgetType, QualityWidgetConfiguration } from '../../../models/index';


const withExtendedProperties = [
    QualityWidgetType.BadValuesMostFrequent,
    QualityWidgetType.ScatteredTags,
    QualityWidgetType.FlatTags,
    QualityWidgetType.OutOfRangeTags,
    QualityWidgetType.MissingTags,
    QualityWidgetType.SuspiciousKPI,
    QualityWidgetType.InvalidKPI,
];

export class QualityBadActorsWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: QualityWidgetConfiguration;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    params: Object;
    redirectUrl: string;
    row = 0;
    sizeX = 12;
    sizeY = 6;
    type = definition.type;

    constructor(configuration?: QualityWidgetConfiguration) {
        super();
        this.guid = Helper.getGuid();
        if (configuration) {
            this.configuration = configuration;
            this.name = configuration.name !== undefined ? configuration.name : this.name;
            this.sizeX = configuration.sizeX !== undefined ? configuration.sizeX : this.sizeX;
            this.sizeY = configuration.sizeY !== undefined ? configuration.sizeY : this.sizeY;
            this.row = configuration.row !== undefined ? configuration.row : this.row;
            this.col = configuration.col !== undefined ? configuration.col : this.col;

            switch (configuration.qualityWidgetType) {
                case QualityWidgetType.BadValuesMostFrequent:
                    this.redirectUrl = 'qualityAnalysis.tagsInError';
                    this.params = {
                        errorSearch: 'bad'
                    };
                    break;
                case QualityWidgetType.FlatTags:
                    this.redirectUrl = 'qualityAnalysis.tagsInError';
                    this.params = {
                        errorSearch: 'flat'
                    };
                    break;
                case QualityWidgetType.OutOfRangeTags:
                    this.redirectUrl = 'qualityAnalysis.tagsInError';
                    this.params = {
                        errorSearch: 'outofrange'
                    };
                    break;
                case QualityWidgetType.ScatteredTags:
                    this.redirectUrl = 'qualityAnalysis.tagsInError';
                    this.params = {
                        errorSearch: 'scatter'
                    };
                    break;
                case QualityWidgetType.MissingTags:
                case QualityWidgetType.MissingTagsPerConnectionPoint:
                    this.redirectUrl = 'qualityAnalysis.tagsInError';
                    this.params = {
                        errorSearch: 'missing'
                    };
                    break;
                case QualityWidgetType.SuspiciousKPI:
                    this.redirectUrl = 'qualityAnalysis.calculated';
                    this.params = {
                        searchString: 'err:suspcious'
                    };
                    break;
                case QualityWidgetType.InvalidKPI:
                    this.redirectUrl = 'qualityAnalysis.calculated';
                    this.params = {
                        searchString: 'err:invalid'
                    };
                    break;
            }

            this.hasExtendedProperties = withExtendedProperties.indexOf(configuration.qualityWidgetType) >= 0;
            if (this.configuration.max === undefined) {
                this.configuration.max = 10;
            }
        }
    }
}